import { render, staticRenderFns } from "./biaoRouter.vue?vue&type=template&id=7f7a8895"
import script from "./biaoRouter.vue?vue&type=script&lang=js"
export * from "./biaoRouter.vue?vue&type=script&lang=js"
import style0 from "./biaoRouter.vue?vue&type=style&index=0&id=7f7a8895&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports